import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import BASE_URL from "../Config";
import { useFormikContext } from "formik";

// Function to fetch data from the API
const getSpotRegistrationData = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/getDelegateAdminDataforprint`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const AdminActivityList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [checkInCount, setCheckInCount] = useState([]);
  const [pagination, setPagination] = useState({
    totalRecords: 0,
    currentPage: 1,
    totalPages: 1,
    pageSize: 25,
  });
  const [search, setSearch] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch data from API
  const fetchData = async () => {
    const payload = {
      page: pagination.currentPage,
      limit: pagination.pageSize,
      sortBy: "created_at",
      sortOrder: "desc",
      search: search,
    };

    try {
      const response = await getSpotRegistrationData(payload);
      setData(response.data || []);

      // Check if response.pagination exists
      if (response.pagination) {
        setPagination(response.pagination);
      } else {
        // If pagination info not provided by API, derive from response
        setPagination((prev) => ({
          ...prev,
          totalRecords: response.data?.length || 0,
          totalPages: 1, // Or calculate manually if backend doesn't support pagination
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Trigger fetch data on page change, page size change, or search change
  useEffect(() => {
    fetchData();
  }, [pagination.currentPage, pagination.pageSize, search]);
  const SendMail = async (userId) => {
    try {
      // Show loading alert
      Swal.fire({
        title: "Sending mail...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Send request
      const res = await axios.post(`${BASE_URL}/sendMail`, {
        id: userId,
      });

      // Close loading and show success
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Mail sent successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(error);

      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Unable to send mail. Please try again.",
      });
    }
  };
  const SendBulkMailUsingNodemailer = async () => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to send mail to all delegates?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      Swal.fire({
        title: "Sending mail...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Send request
      const res = await axios.post(
        `${BASE_URL}/sendBulkMailUsingNodemailer`,
        {}
      );

      // Close loading and show success
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Mail sent successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(error);

      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Unable to send mail. Please try again.",
      });
    }
  };

  const SendBulkMailtoPreRegisterdDeleget = async (userId) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to send mail to all pre-registered delegates Registered By Admin?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      Swal.fire({
        title: "Sending mail...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Send request
      const res = await axios.post(
        `${BASE_URL}/SendBulkMailtoPreRegisterdDeleget`
      );

      // Close loading and show success
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Mail sent successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(error);

      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Unable to send mail. Please try again.",
      });
    }
  };
  const GetCheckinCount = async (userId) => {
    try {
      // Send request
      const res = await axios.post(`${BASE_URL}/getActionTypeCount`);
      setCheckInCount(res?.data?.data?.count);
    } catch (error) {
      console.error(error);

      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Unable to send mail. Please try again.",
      });
    }
  };
  useEffect(() => {
    GetCheckinCount();
  }, []);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handlePageSizeChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };
  const handleEdit = (edit) => {
    navigate(`/express-entry/separate-activity/${edit}`);
  };

  const handleBadgePrintCopy = async (item) => {
    try {
      // Navigate to Badge Print page
      const payload = {
        id: item.id,
        batch_assign: 2, // Corrected from 'id' to 'item.id'
      };

      const response = await axios.post(
        `${BASE_URL}/updateBadgeStatus`,
        payload
      );

      navigate("/badge-print-card", {
        state: {
          id: item.id,
          name: item.name,
          company_name:
            item?.organization_name ||
            item?.deletegate_registation?.organization_name ||
            "",
          qrUrl:
            item?.url_for_qr || `https://event.sopa.org/delegate/${item.id}/0`,
        },
      });
    } catch (error) {
      console.error("Error updating badge status:", error);
      alert("Something went wrong while updating badge status.");
    }
  };
  const handleLogout = () => {
    // Clear user session or authentication data
    sessionStorage.clear(); // or localStorage.clear();

    // Redirect to the homepage
    navigate("/admin/login");
  };

  return (
    <div id="page" className="page">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <div>
          <button
            style={{
              background: "#44929f",
              padding: "6px 20px",
              borderRadius: "40px",
              fontSize: "16px",
              fontWeight: 600,
              color: "#fff",
              marginRight: "10px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => navigate("/express-entry/separate-activity/0")}
          >
            Register
          </button>
          <button
            style={{
              background: "#44929f",
              padding: "6px 20px",
              borderRadius: "40px",
              fontSize: "16px",
              fontWeight: 600,
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          marginTop: "10px",
        }}
      >
        <div>
          <button
            style={{
              background: "#44929f",
              padding: "6px 20px",
              borderRadius: "40px",
              fontSize: "16px",
              fontWeight: 600,
              color: "#fff",
              marginRight: "10px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={SendBulkMailtoPreRegisterdDeleget}
          >
            Email - Pre Register{" "}
          </button>
          <button
            style={{
              background: "#44929f",
              padding: "6px 20px",
              borderRadius: "40px",
              fontSize: "16px",
              fontWeight: 600,
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
            onClick={SendBulkMailUsingNodemailer}
          >
            Email - Register By Admin
          </button>
          <button
            style={{
              background: "#44929f",
              padding: "6px 20px",
              borderRadius: "40px",
              fontSize: "16px",
              fontWeight: 600,
              color: "#fff",
              border: "none",
            }}
          >
            Check In Count - {checkInCount}
          </button>
        </div>
      </div>
      <div className="inner-page-wrapper">
        <section className="division wide-30">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <h4 style={{ fontWeight: 700 }} className="font-bold">
                      Registration Request
                    </h4>
                    {/* Entries and Search UI */}
                    <div className="d-flex flex-column p- flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 mt-3 gap-3">
                      <div>
                        Show{" "}
                        <select
                          className="form-select d-inline-block w-auto border"
                          value={pagination.pageSize}
                          onChange={handlePageSizeChange}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                        </select>{" "}
                      </div>
                      <div className={` ${!isMobile ? "w-80" : "w-100"}`}>
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search..."
                          value={search}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                      <table
                        id="request-list"
                        className="table table-bordered"
                        style={{ width: "100%" }}
                        data-order='[[0,"desc"]]'
                      >
                        <thead>
                          <tr className="text-center">
                            <th>Batch NO.</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Company</th>
                            <th>Category</th>
                            <th>Amount</th>
                            <th>Edit</th>
                            <th>Mail</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item) => (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>{item.mobile}</td>
                              <td>
                                {" "}
                                {item?.organization_name ||
                                  item?.deletegate_registation
                                    ?.organization_name ||
                                  "-"}
                              </td>
                              <td>
                                {item.deletegate_registation
                                  ?.deletegate_category || "-"}
                              </td>{" "}
                              <td>{item.total_delegate || "-"}</td>
                              <td>
                                <button onClick={() => handleEdit(item.id)}>
                                  <i
                                    className="fas fa-edit"
                                    title="Edit"
                                    style={{
                                      cursor: "pointer",
                                      color: "#007bff",
                                    }}
                                  ></i>
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="flex items-center gap-2 bg-primary text-white font-semibold py-2 px-4 rounded-full hover:bg-blue-700 transition duration-200"
                                  style={{ color: "black" }}
                                  onClick={() => SendMail(item?.id)}
                                >
                                  Notify Via Mail{" "}
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn bg-primary btn-labeled rounded-pill link-white"
                                  style={{ color: "black" }}
                                  onClick={() => handleBadgePrintCopy(item)}
                                >
                                  Badge Print Copy
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5">
                      <div className="mb-3 mb-md-0">
                        Showing{" "}
                        {(pagination.currentPage - 1) * pagination.pageSize + 1}{" "}
                        to{" "}
                        {Math.min(
                          pagination.currentPage * pagination.pageSize,
                          pagination.totalRecords
                        )}{" "}
                        of {pagination.totalRecords} entries
                      </div>

                      <nav>
                        <ul className="pagination mb-0 flex-wrap">
                          {/* Previous button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage - 1)
                              }
                              disabled={pagination.currentPage === 1}
                            >
                              Previous
                            </button>
                          </li>

                          {/* Page numbers with ellipsis */}
                          {Array.from(
                            { length: pagination.totalPages },
                            (_, i) => i + 1
                          )
                            .filter(
                              (page) =>
                                page === 1 ||
                                page === pagination.totalPages ||
                                (page >= pagination.currentPage - 2 &&
                                  page <= pagination.currentPage + 2)
                            )
                            .map((page, idx, arr) => {
                              const prevPage = arr[idx - 1];
                              const showEllipsis =
                                prevPage && page - prevPage > 1;
                              return (
                                <React.Fragment key={page}>
                                  {showEllipsis && (
                                    <li className="page-item disabled">
                                      <span className="page-link">…</span>
                                    </li>
                                  )}
                                  <li
                                    className={`page-item ${
                                      pagination.currentPage === page
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(page)}
                                    >
                                      {page}
                                    </button>
                                  </li>
                                </React.Fragment>
                              );
                            })}

                          {/* Next button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === pagination.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage + 1)
                              }
                              disabled={
                                pagination.currentPage === pagination.totalPages
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AdminActivityList;
